export default "__VITE_ASSET__c5026ca2__"